import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const Container = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`

export const LoadingIcon = styled(FontAwesomeIcon)`
  align-self: center;
  padding: ${({ theme }) => theme.functions.getSpace(4)};
`
